// https://prototype.sqprod.co/#/docs/squareup.franklin.api.FormBlocker.Element.PaymentPlanSummaryElement

import styled from '@emotion/styled'
import { v4 as uuidv4 } from 'uuid'

import { PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'
import { FormBlockerElementPaymentPlanSummaryElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { NestedCard } from '@cash-web/shared-feature-common'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'

import { DetailRowElement } from '../DetailRowElement/DetailRowElement'

type PaymentPlanSummaryElementProps = FormBlockerElementPaymentPlanSummaryElement

const Card = styled(NestedCard)`
  border-radius: 1rem;
  width: 100%;
`

export function PaymentPlanSummaryElement({ header, items }: PaymentPlanSummaryElementProps) {
  const textTokenizer = useTextTokenizer()

  return (
    <Card>
      <Stack space={spacing.l}>
        <PaddingInset>
          <Text as="p" typography="titleBarPageTitle">
            {textTokenizer(header)}
          </Text>
        </PaddingInset>
        <div>
          {items?.map(item => {
            const key = uuidv4()
            return <DetailRowElement key={key} {...item} />
          })}
        </div>
      </Stack>
    </Card>
  )
}
